import { render, staticRenderFns } from "./tiku.vue?vue&type=template&id=6cb95c09&scoped=true&"
import script from "./tiku.vue?vue&type=script&lang=js&"
export * from "./tiku.vue?vue&type=script&lang=js&"
import style0 from "./tiku.vue?vue&type=style&index=0&id=6cb95c09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb95c09",
  null
  
)

export default component.exports